<ag-shr-modal-window
  #settingsModalRef
  [title]="caption"
  [width]="620"
  [height]="'auto'"
  [useScrollView]="false"
  [inProgress]="inProgressSig()"
  [saveButtonDisabled]="isLoadingSig() || inProgressSig() || (!isControlled && periodInvalidSig())"
  [actionTitle]="'Save'"
  [cancelTitle]="'Cancel'"
  [customClass]="'report-default-settings-modal'"
  [onCloseModal]="handleClosePopup"
  (onHidden)="onModalHidden()"
  (onSaveClick)="onSave()"
>
  @if (settingsModalRef?.popupComponent?.visible) {
    <div class="report-default-settings-modal__content">
      @if (!isControlled) {
        <ag-shr-report-period-control
          [selection]="periodSelectionSig()"
          [paid]="paidSig()"
          [through]="dataAvailableThroughSig()"
          [from]="dataAvailableFromSig()"
          (selectionChange)="onPeriodSelectionChange($event)"
        ></ag-shr-report-period-control>
        <p>Standard period defaults always use the latest available period.</p>
      }
      <dx-form
        #settingsFormRef
        class="report-default-settings-modal__form report-display-options-form"
        [formData]="formDataSig()"
        [colCount]="2"
        labelMode="floating"
        [showColonAfterLabel]="false"
      >
        <dxi-item
          [dataField]="ReportDefaultSettingsFormKeys.title"
          editorType="dxTextBox"
          [label]="{ text: 'Bulletin Title' }"
          [editorOptions]="titleEditorOptions"
          [colSpan]="2"
          [visible]="isVisibleKey(ReportDefaultSettingsFormKeys.title)"
        ></dxi-item>

        <dxi-item
          [dataField]="ReportDefaultSettingsFormKeys.subtitle"
          editorType="dxTextBox"
          [label]="{ text: 'Report Title' }"
          [editorOptions]="subtitleEditorOptions"
          [colSpan]="2"
        ></dxi-item>

        <dxi-item itemType="group" [colCount]="6" [colCountByScreen]="thresholdRowColCountByScreen" [colSpan]="1">
          <dxi-item
            [dataField]="ReportDefaultSettingsFormKeys.displayThreshold"
            editorType="dxNumberBox"
            [label]="{ text: 'Threshold' }"
            [editorOptions]="displayThresholdEditorOptionsSig()"
            [colSpan]="5"
          ></dxi-item>
          <dxi-item
            [dataField]="ReportDefaultSettingsFormKeys.includeThreshold"
            editorType="dxSwitch"
            [label]="{ text: 'Include Threshold', visible: false }"
            [editorOptions]="includeThresholdEditorOptions"
            cssClass="ag-inline-switch"
          ></dxi-item>
        </dxi-item>

        <dxi-item
          [dataField]="ReportDefaultSettingsFormKeys.rowsPerPage"
          editorType="dxNumberBox"
          [label]="{ text: 'Rows Per Page' }"
          [editorOptions]="rowsPerPageEditorOptions"
          [colSpan]="1"
        >
          <dxi-validation-rule type="required" [message]="Messages.REQUIRED_TEXT"></dxi-validation-rule>
        </dxi-item>
        @if (ntpVariableSig(); as ntpVariable) {
          <dxi-item
            [dataField]="ReportDefaultSettingsFormKeys.ntpDisplayMode"
            editorType="dxSelectBox"
            cssClass="production-report-viewer__ntp-help-field"
            [label]="{ text: ntpVariable.label, template: 'reportVariableLabel', visible: true, location: 'top' }"
            [editorOptions]="ntpEditorOptionsSig()"
            [visible]="isVisibleKey(ReportDefaultSettingsFormKeys.ntpDisplayMode)"
            [colSpan]="2"
          ></dxi-item>
        }
        @if (isPersonalSig()) {
          <dxi-item
            [dataField]="ReportDefaultSettingsFormKeys.showSuppressedAgents"
            editorType="dxSwitch"
            cssClass="ag-switch-with-label"
            [label]="{
              text: 'Show Suppressed Agents',
              template: 'reportVariableLabel',
              visible: true,
              location: 'left',
            }"
            [editorOptions]="yesNoEditorOptions"
            [visible]="isVisibleKey(ReportDefaultSettingsFormKeys.showSuppressedAgents)"
            [colSpan]="2"
          ></dxi-item>
        }
        <dxi-item
          [dataField]="ReportDefaultSettingsFormKeys.showTotals"
          editorType="dxSwitch"
          cssClass="ag-switch-with-label"
          [label]="{ text: 'Show Totals', template: 'reportVariableLabel', visible: true, location: 'left' }"
          [editorOptions]="yesNoEditorOptions"
          [visible]="isVisibleKey(ReportDefaultSettingsFormKeys.showTotals)"
          [colSpan]="2"
        ></dxi-item>
        <div *dxTemplate="let labelData of 'reportVariableLabel'" class="production-report-viewer__settings-label">
          <span>{{ labelData.text }}</span>
          <span
            #helpIcon
            class="production-report-viewer__settings-help-icon"
            tabindex="0"
            role="img"
            aria-label="Help"
          >
            ?
            <dx-tooltip
              [target]="helpIcon"
              showEvent="mouseenter focusin"
              hideEvent="mouseleave focusout"
              [position]="'top'"
              [width]="360"
            >
              <div class="production-report-viewer__settings-help-tooltip" *dxTemplate="let tooltipData of 'content'">
                {{ getVariableHelpText(labelData.text) }}
              </div>
            </dx-tooltip>
          </span>
        </div>
      </dx-form>
    </div>
  }
</ag-shr-modal-window>
